import React, { useContext, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { FilterContext } from '../../../../../context/FilterProvider';
import { Mode } from '../../../../../types/FiltersTypes';
import FILTER_TYPES from '../../../filterTypes';
import ObrasAPI from '../../../../../services/APIObras';
import { Option } from '../../../../../types/Option';

import TextField from '@mui/material/TextField';
import styles from './containKeywordTextField.module.scss';
import { TFunction } from 'i18next';


interface ContainKeywordTextFieldProps {
  t: TFunction<'translations'>;
  filterType: string;
  isNumber?: boolean;
  isExactWord?: boolean;
  placeholder?: string;
}
const ContainKeywordTextField = (props: ContainKeywordTextFieldProps) => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const { t, filterType, isNumber, placeholder, isExactWord } = props;
  const filterContext = useContext(FilterContext);
  const api = ObrasAPI.getInstance();

  const resolveProjectFilterLabel = async (value: string): Promise<string> => {
    if (filterType !== FILTER_TYPES.projectName) {
      return `${t(isExactWord ? 'filters.matches' : 'filters.contain')}: ${value}`;
    }

    const centers = await api.getCentersByText(value);
    const normalizedValue = value.trim().toLowerCase();
    const exactMatch = centers.find((center: Option) => center.code?.toLowerCase() === normalizedValue);

    return exactMatch?.name ? `${t('filters.projectName')}: ${exactMatch.name}` : `${t('filters.projectName')}: ${value}`;
  };

  const handleAddKeyword = async (value: string) => {
    const normalizedValue = value
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    if (normalizedValue.length >= 3) {
      const inputName = await resolveProjectFilterLabel(value);
      filterContext.handleChange(filterType, { code: normalizedValue, name: inputName }, Mode.ADD);
      setTextFieldValue('');
    }
  };

  return (
    <div data-testid='test-keywordfield' id='keywordfield' className={styles.keywordTextField}>
      <TextField
        value={textFieldValue}
        onChange={
          (e) => {
            setTextFieldValue(
              isNumber ? e.target.value.replace(/[^0-9.]/gi, '') : e.target.value
            );
          }
        }
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            handleAddKeyword(textFieldValue);
          }
        }}
        placeholder={placeholder || t('filters.filtersPlaceHolder.keyword') as string}
        variant='outlined'
        InputProps={
          {
            endAdornment: <button
              disabled={textFieldValue.trim().length < 3}
              onClick={() => {
                const trimmedValue = textFieldValue.trim();
                if (trimmedValue.length > 0) handleAddKeyword(trimmedValue);
              }}>
              {`${t('filters.add')}`}
            </button>,
          }
        }
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF',
            height: '45px',
            '&.Mui-focused fieldset': {
              border: '1px solid #7A7A7A',
              color: 'rgba(122, 122, 122, 1)',
            },
          },
        }}
      />
    </div>
  );
};

export default withTranslation()(ContainKeywordTextField);
